import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../../lib/api/settings';
import { HoneyPot, FormNote } from '../FormParts';
import { subscribeNewsletter } from '../../lib/api/forms';

import footerBG from '../../assets/img/footer/bg-1-1.jpg';
import Logo from '../../assets/img/logo/sanasa-logo-white.png';
import { gallery } from '../../data/images';

const [footerImg1, footerImg2, footerImg3, footerImg4, footerImg5, footerImg6] = gallery;

const FooterTwo = (props) => {
  const { contact } = useSiteSettings();
  const [news, setNews] = useState({ status: 'idle', message: '' });

  const handleSubscribe = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    setNews({ status: 'sending', message: '' });
    try {
      await subscribeNewsletter(form.elements.email.value, form.elements.website.value);
      form.reset();
      setNews({ status: 'success', message: 'Thank you. You are on the list.' });
    } catch (err) {
      setNews({ status: 'error', message: err.message });
    }
  };
  const { footerClass, footerLogo, btnClass, copyrightTextClass } = props;

  return (
    <footer>
      <div
        className={
          footerClass
            ? footerClass
            : 'it-footer-area it-footer-bg it-footer-style-5 ed-footer-style-2 black-bg pb-70'
        }
        style={{ backgroundImage: `url(${footerBG})` }}
      >
        <div className="it-footer-border">
          <div className="container">
            <div className="row">
              <div className="col-xl-4 col-lg-4 col-md-4">
                <div className="it-footer-top-info d-flex align-items-center it-footer-top-col-1">
                  <div className="it-footer-top-icon">
                    <span>
                      <i className="fa-light fa-location-dot"></i>
                    </span>
                  </div>
                  <div className="it-footer-top-text">
                    <span>Address:</span>
                    <a target="_blank" rel="noreferrer" href="https://www.google.com/maps/search/SANASA+Campus+Paragammana+Kegalle">
                      {contact.address}
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4">
                <div className="it-footer-top-info d-flex align-items-center it-footer-top-col-2">
                  <div className="it-footer-top-icon">
                    <span>
                      <i className="fa-light fa-phone phone"></i>
                    </span>
                  </div>
                  <div className="it-footer-top-text">
                    <span>Phone:</span>
                    <a href={contact.generalPhoneHref}>{contact.generalPhone}</a>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4">
                <div className="it-footer-top-info d-flex align-items-center justify-content-md-end border-none it-footer-top-col-3">
                  <div className="it-footer-top-icon">
                    <span>
                      <i className="fa-light fa-envelope"></i>
                    </span>
                  </div>
                  <div className="it-footer-top-text">
                    <span>Email:</span>
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="it-footer-wrap pt-120">
          <div className="container">
            <div className="row">
              <div
                className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-50 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
              >
                <div className="it-footer-widget footer-col-5">
                  <div className="it-footer-logo pb-25">
                    <Link to="/">
                      <img
                        src={footerLogo ? footerLogo : Logo}
                        alt="SANASA Campus Ltd."
                        width="240"
                      />
                    </Link>
                  </div>
                  <div className="it-footer-text pb-5">
                    <p>
                      The first co-operative degree-awarding{' '}
                      <br />
                      university institute of Sri Lanka.
                    </p>
                  </div>
                  <div className="it-footer-social">
                    <a href={contact.facebook} target="_blank" rel="noreferrer">
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                    <a href={contact.instagram} target="_blank" rel="noreferrer">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                    <a href={contact.youtube} target="_blank" rel="noreferrer">
                      <i className="fa-brands fa-youtube"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-2 col-lg-3 col-md-6 col-sm-6 mb-50 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".5s"
              >
                <div className="it-footer-widget footer-col-6">
                  <h4 className="it-footer-title">Programs</h4>
                  <div className="it-footer-list">
                    <ul>
                      <li>
                        <Link to="/programs?type=degree">
                          <i className="fa-regular fa-angle-right"></i>B.Sc. Degrees
                        </Link>
                      </li>
                      <li>
                        <Link to="/programs?type=diploma">
                          <i className="fa-regular fa-angle-right"></i>Diplomas
                        </Link>
                      </li>
                      <li>
                        <Link to="/programs?type=short">
                          <i className="fa-regular fa-angle-right"></i>Short Courses
                        </Link>
                      </li>
                      <li>
                        <Link to="/research">
                          <i className="fa-regular fa-angle-right"></i>Research
                        </Link>
                      </li>
                      <li>
                        <Link to="/news">
                          <i className="fa-regular fa-angle-right"></i>News
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-50 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".7s"
              >
                <div className="it-footer-widget footer-col-4">
                  <h4 className="it-footer-title">Gallery</h4>
                  <div className="it-footer-gallery-box">
                    <div className="row gx-10">
                      <div className="col-md-4 col-4">
                        <div className="it-footer-thumb mb-10">
                          <a href="#">
                            <img src={footerImg1} alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="col-md-4 col-4">
                        <div className="it-footer-thumb mb-10">
                          <a href="#">
                            <img src={footerImg2} alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="col-md-4 col-4 mb-10">
                        <div className="it-footer-thumb">
                          <a href="#">
                            <img src={footerImg3} alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="col-md-4 col-4">
                        <div className="it-footer-thumb">
                          <a href="#">
                            <img src={footerImg4} alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="col-md-4 col-4">
                        <div className="it-footer-thumb">
                          <a href="#">
                            <img src={footerImg5} alt="" />
                          </a>
                        </div>
                      </div>
                      <div className="col-md-4 col-4">
                        <div className="it-footer-thumb">
                          <a href="#">
                            <img src={footerImg6} alt="" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-3 col-lg-3 col-md-6 col-sm-8 mb-50 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".9s"
              >
                <div className="it-footer-widget footer-col-8">
                  <h4 className="it-footer-title">Newsletter</h4>
                  <form className="it-footer-input-box p-relative" onSubmit={handleSubscribe}>
                    <input
                      className="mb-20"
                      type="email"
                      name="email"
                      placeholder="Enter your email:"
                      required
                      maxLength={200}
                    />
                    <HoneyPot />
                    <button
                      type="submit"
                      className={btnClass ? btnClass : 'it-btn-white sky-bg'}
                      disabled={news.status === 'sending'}
                    >
                      <span>{news.status === 'sending' ? 'Sending...' : 'Subscribe'}</span>
                    </button>
                    <FormNote status={news.status}>{news.message}</FormNote>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-copyright-area it-copyright-height">
        <div className="container">
          <div className="row">
            <div
              className="col-12 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div
                className={
                  copyrightTextClass
                    ? copyrightTextClass
                    : 'it-copyright-text style-2 text-center'
                }
              >
                <p>
                  Copyright &copy; {new Date().getFullYear()}{' '}
                  <Link to="/">SANASA Campus Ltd.</Link> | All Rights Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default FooterTwo;
